

export default {
  getClubInfo (state) {
    return state.clubInfo
  }
}
